var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 333,
    viewBox: "0 0 501 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_1225)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.03 327.614H12.7271C-2.05787 306.706 0.134241 268.766 8.57151 247.74C21.2668 216.076 47.3593 204.067 69.7929 181.671C104.401 147.116 100.609 91.0559 130.652 53.3358C156.011 21.4981 198.781 4.23665 238.696 7.79604C278.146 11.3239 285.03 52.1939 307.227 77.5034C315.814 87.2917 326.018 94.3082 337.049 99.3874C354.689 107.514 374.441 110.696 393.043 112.381C439.408 116.578 487.217 129.343 494.968 200.94C502.956 274.695 461.03 327.614 461.03 327.614Z",
    fill: "#71C2C9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M501 327.952C501 330.74 388.847 333 250.5 333C112.153 333 0 330.74 0 327.952C0 325.165 112.153 322.905 250.5 322.905C388.847 322.905 501 325.165 501 327.952Z",
    fill: "#CADCED"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.983 292.949H223.919L235.928 270.656H318.992L306.983 292.949Z",
    fill: "#C94747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273.186 292.681L278.13 289.61L278.256 286.704L274.542 289.012L270.829 287.043L270.71 282.854L274.424 280.546L271.759 279.373L266.807 282.444L266.799 285.2L266.468 285.405L244.689 298.934L241.424 297.682L236.48 300.761L236.354 303.659L240.068 301.351L243.782 303.32L243.9 307.517L240.186 309.825L242.852 310.99L247.803 307.919L247.811 305.163L269.922 291.429L273.186 292.681Z",
    fill: "#AAB8C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.534 298.398C243.167 299.493 239.8 300.587 236.433 301.69L236.346 303.659L240.06 301.351L243.774 303.312L243.9 307.509L240.186 309.817L242.852 310.982L247.796 307.911V305.155L269.922 291.421L273.178 292.673L278.122 289.602L278.186 288.24C267.446 290.933 257.053 294.981 246.534 298.39V298.398Z",
    fill: "#8F9BA5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.596 280.235L231.24 284.368C230.621 284.955 230.596 285.932 231.184 286.55L248.497 304.751C249.085 305.369 250.063 305.394 250.682 304.807L255.038 300.674C255.657 300.087 255.682 299.11 255.095 298.492L237.781 280.291C237.193 279.673 236.215 279.648 235.596 280.235Z",
    fill: "#F89334"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248.584 302.32C248.26 302.627 247.748 302.611 247.44 302.288L233.736 287.878C233.428 287.555 233.444 287.043 233.767 286.736C234.091 286.429 234.603 286.444 234.911 286.767L248.615 301.178C248.923 301.501 248.907 302.013 248.584 302.32Z",
    fill: "#CF7A2B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.618 300.391C250.295 300.698 249.783 300.682 249.475 300.359L235.77 285.948C235.463 285.625 235.479 285.114 235.802 284.807C236.125 284.499 236.638 284.515 236.945 284.838L250.65 299.249C250.958 299.572 250.942 300.084 250.618 300.391Z",
    fill: "#CF7A2B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.653 298.461C252.329 298.768 251.817 298.753 251.509 298.43L237.805 284.019C237.497 283.696 237.513 283.184 237.836 282.877C238.159 282.57 238.672 282.586 238.98 282.909L252.684 297.32C252.992 297.642 252.976 298.154 252.653 298.461Z",
    fill: "#CF7A2B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M299.74 294.286L296.764 289.073C296.341 288.333 295.397 288.075 294.656 288.497L272.818 300.932C272.076 301.354 271.818 302.296 272.241 303.037L275.217 308.25C275.64 308.99 276.583 309.248 277.325 308.826L299.163 296.391C299.905 295.969 300.163 295.027 299.74 294.286Z",
    fill: "#F8897A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M275.165 301.596C274.945 301.21 275.079 300.714 275.465 300.493L292.75 290.65C293.136 290.429 293.633 290.563 293.854 290.949C294.074 291.335 293.94 291.831 293.554 292.051L276.269 301.895C275.883 302.115 275.386 301.981 275.165 301.596Z",
    fill: "#CF7265"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M276.553 304.029C276.332 303.643 276.466 303.147 276.853 302.926L294.137 293.083C294.524 292.862 295.02 292.996 295.241 293.382C295.462 293.768 295.328 294.264 294.942 294.485L277.657 304.328C277.271 304.549 276.774 304.415 276.553 304.029Z",
    fill: "#CF7265"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M277.949 306.47C277.728 306.084 277.862 305.588 278.249 305.368L295.533 295.524C295.92 295.304 296.416 295.438 296.637 295.823C296.858 296.209 296.724 296.705 296.338 296.926L279.053 306.769C278.667 306.99 278.17 306.856 277.949 306.47Z",
    fill: "#CF7265"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M277.799 298.658H307.44V321.865C307.44 325.401 304.569 328.267 301.029 328.267H277.791V298.666L277.799 298.658Z",
    fill: "#F15555"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.383 298.658H286.812V321.865C286.812 325.401 283.942 328.267 280.401 328.267H224.794C221.254 328.267 218.383 325.401 218.383 321.865V298.658Z",
    fill: "#FF5A5A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.72
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M307.448 298.658H286.812V301.682H307.448V298.658Z",
    fill: "#B8CDE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.72
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M286.812 298.658H218.383V301.682H286.812V298.658Z",
    fill: "#B8CDE0"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M310.31 291.705H281.269C280.363 291.705 279.628 292.438 279.628 293.343V297.012C279.628 297.917 280.363 298.65 281.269 298.65H310.31C311.216 298.65 311.95 297.917 311.95 297.012V293.343C311.95 292.438 311.216 291.705 310.31 291.705Z",
    fill: "#F15555"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M287.813 291.705H215.513C214.607 291.705 213.873 292.438 213.873 293.343V297.012C213.873 297.917 214.607 298.65 215.513 298.65H287.813C288.719 298.65 289.454 297.917 289.454 297.012V293.343C289.454 292.438 288.719 291.705 287.813 291.705Z",
    fill: "#FF5A5A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M317.715 270.656H235.928L234.651 266.206H317.715V270.656Z",
    fill: "#FF5A5A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M306.983 292.949L302.188 295.185L317.715 266.206L318.992 270.656L306.983 292.949Z",
    fill: "#F15555"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M223.919 292.949L219.125 295.185L234.651 266.206L235.928 270.656L223.919 292.949Z",
    fill: "#F15555"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M450.896 129.24H438.808V126.382C438.808 125.193 439.77 124.232 440.961 124.232H448.744C449.934 124.232 450.896 125.193 450.896 126.382V129.24Z",
    fill: "#8CAFD4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M416.753 327.976H455.336V237.164H416.753V327.976Z",
    fill: "#E8F4FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M354.475 270.403L419.805 237.164L447.514 270.403V327.976H340.006L353.427 295.847C356.802 287.759 357.172 278.735 354.475 270.403Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M342.955 320.912L340.006 327.976H455.336V320.912H342.955Z",
    fill: "#E8F4FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M410.635 280.239H356.218C356.084 276.924 355.516 273.609 354.476 270.403L418.126 238.022C422.084 245.952 425.333 256.536 425.333 263.529C425.333 269.451 421.619 280.247 410.627 280.247L410.635 280.239Z",
    fill: "#E8F4FF"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M403.356 218.28H455.336V214.028H403.356V218.28Z",
    fill: "#BBD6F2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M401.558 237.164H455.336V218.272H401.558V237.164Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M428.447 218.273H455.336V139.399H416.753L428.447 218.273Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M455.336 139.399H416.753V143.88H455.336V139.399Z",
    fill: "#E8F4FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M436.041 218.273H455.336V139.399H436.041V218.273Z",
    fill: "#E8F4FF"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M420.861 126.949H455.336V139.399H416.895C414.545 139.399 412.645 137.501 412.645 135.154C412.645 130.619 416.327 126.949 420.861 126.949Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M360.184 270.656H403.601C412.55 270.656 419.805 263.411 419.805 254.473V216.808C419.805 214.241 417.723 212.17 415.16 212.17H303.828L299.57 221.092C298.016 224.352 297.977 228.124 299.452 231.416C310.191 255.3 333.966 270.663 360.176 270.663L360.184 270.656Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M298.466 227.77C298.206 225.502 298.569 223.186 299.57 221.084L303.828 212.162H415.161C417.731 212.162 419.805 214.241 419.805 216.8V227.77H298.466Z",
    fill: "#E8F4FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M300.911 218.273L303.828 212.154H415.161C417.731 212.154 419.805 214.233 419.805 216.792V218.265H300.911V218.273Z",
    fill: "#E8F4FF"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M339.541 200.271H398.065C404.082 200.271 409.799 202.901 413.718 207.461L419.805 214.556H300.69C299.31 214.556 298.095 213.666 297.678 212.359C297.157 210.721 298.04 208.972 299.665 208.413L308.181 205.492C318.274 202.035 328.872 200.271 339.548 200.271H339.541Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.72
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M267.714 113.704V7.96914C267.714 4.85518 265.186 2.33081 262.068 2.33081L179.47 2.33081C176.351 2.33081 173.824 4.85518 173.824 7.96914V113.704C173.824 116.818 176.351 119.342 179.47 119.342H262.068C265.186 119.342 267.714 116.818 267.714 113.704Z",
    fill: "#B8CDE0"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M265.664 111.373V5.63833C265.664 2.52437 263.136 0 260.018 0L177.419 0C174.301 0 171.773 2.52437 171.773 5.63833V111.373C171.773 114.487 174.301 117.011 177.419 117.011H260.018C263.136 117.011 265.664 114.487 265.664 111.373Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M258.59 4.55151H178.854C177.461 4.55151 176.331 5.67972 176.331 7.07144V109.932C176.331 111.323 177.461 112.451 178.854 112.451H258.59C259.984 112.451 261.114 111.323 261.114 109.932V7.07144C261.114 5.67972 259.984 4.55151 258.59 4.55151Z",
    fill: "#ADE2FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M229.431 112.459H184.114L234.446 4.55151H261.114V41.744L229.431 112.459Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M225.441 4.55151L176.331 112.451V95.6152L217.776 4.55151H225.441Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M185.525 189.939C189.129 186.277 197.929 182.513 198.994 180.23C200.484 177.04 201.123 174.331 203.882 172.292C206.642 170.244 208.874 168.032 210.356 166.362C211.839 164.693 213.692 163.716 215.971 163.842C218.257 163.968 216.105 167.165 214.662 168.079C213.219 168.984 211.815 171.646 211.61 172.938C211.405 174.229 216.735 174.52 220 173.977C223.264 173.434 226.497 174.245 229.131 174.473C231.765 174.709 232.624 176.324 232.624 176.324C232.624 176.324 234.501 176.513 235.873 177.71C237.245 178.907 235.163 180.001 235.163 180.001C235.163 180.001 235.479 180.867 234.146 181.427C232.814 181.986 230.393 181.041 230.393 181.041C230.393 181.041 229.904 182.631 226.907 182.285C223.919 181.946 218.667 182.639 215.174 183.309C211.681 183.97 207.659 187.403 205.01 186.592C202.361 185.773 192.733 198.216 192.733 198.216L185.518 189.939H185.525Z",
    fill: "#FEC4AD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M156.775 196.121C163.533 195.081 186.818 185.994 197.716 181.623C200.01 186.293 200.933 187.978 203.448 190.561C185.155 202.452 171.04 211.067 159.409 214.54C156.066 215.54 151.839 216.036 147.084 216.138C134.61 216.406 115.086 216.162 101.294 212.902L107.043 191.396C107.043 191.396 149.481 197.255 156.775 196.129V196.121Z",
    fill: "#FFBC00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.72
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M262.423 237.731C259.395 237.731 256.722 239.204 255.058 241.464C255.034 241.495 255.003 241.535 254.979 241.566C254.861 241.739 254.743 241.913 254.632 242.094C254.608 242.141 254.577 242.18 254.545 242.228H243.277V241.157C243.277 240.755 242.954 240.432 242.552 240.432H239.303V242.228H225.299V251.496H239.303V253.292H242.552C242.954 253.292 243.277 252.969 243.277 252.567V251.496H246.731H254.545C254.577 251.551 254.616 251.606 254.648 251.662C254.735 251.803 254.821 251.945 254.916 252.079C254.971 252.158 255.026 252.229 255.082 252.299C255.192 252.449 255.302 252.599 255.421 252.74C257.1 254.733 259.608 256.001 262.415 256.001C267.461 256.001 271.562 251.914 271.562 246.866C271.562 241.818 267.469 237.731 262.415 237.731H262.423Z",
    fill: "#B8CDE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.72
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M275.938 151.565H174.447C172.333 151.565 170.614 153.274 170.614 155.393V160.354C170.614 162.464 172.325 164.181 174.447 164.181H175.101L178.791 168.236L187.733 178.056C191.952 182.679 197.921 185.317 204.182 185.317H246.195C252.456 185.317 258.425 182.679 262.644 178.056L271.585 168.236L275.276 164.181H275.93C278.044 164.181 279.763 162.472 279.763 160.354V155.393C279.763 153.282 278.051 151.565 275.93 151.565H275.938Z",
    fill: "#B8CDE0"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M263.014 252.701C268.066 252.701 272.161 248.611 272.161 243.566C272.161 238.521 268.066 234.432 263.014 234.432C257.962 234.432 253.867 238.521 253.867 243.566C253.867 248.611 257.962 252.701 263.014 252.701Z",
    fill: "#8CAFD4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M263.014 251.48C267.391 251.48 270.939 247.937 270.939 243.566C270.939 239.195 267.391 235.652 263.014 235.652C258.637 235.652 255.089 239.195 255.089 243.566C255.089 247.937 258.637 251.48 263.014 251.48Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M263.282 237.621H256.083C254.711 239.219 253.867 241.29 253.867 243.566C253.867 245.842 254.679 247.85 256.012 249.441H263.274C266.539 249.441 269.188 246.795 269.188 243.535C269.188 240.275 266.539 237.629 263.274 237.629L263.282 237.621Z",
    fill: "#B8CDE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M269.014 244.999C269.798 241.694 267.751 238.379 264.442 237.596C261.132 236.813 257.813 238.858 257.029 242.163C256.245 245.468 258.292 248.782 261.602 249.565C264.911 250.348 268.23 248.304 269.014 244.999Z",
    fill: "#E8F4FF"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M225.898 248.205V238.936H262.47C265.033 238.936 267.114 241.015 267.114 243.574C267.114 246.133 265.033 248.212 262.47 248.212H225.898V248.205Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M247.33 238.936H243.135V248.204H247.33V238.936Z",
    fill: "#E8F4FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M225.898 238.936V248.204H232.388V238.936H225.898Z",
    fill: "#B8CDE0"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M239.902 248.874V238.251C239.902 237.629 240.407 237.133 241.022 237.133H243.143C243.545 237.133 243.869 237.455 243.869 237.857V249.268C243.869 249.669 243.545 249.992 243.143 249.992H241.022C240.399 249.992 239.902 249.488 239.902 248.874Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M239.902 237.133V250H241.196V237.133H239.902Z",
    fill: "#E8F4FF"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M225.188 182.639H215.907V234.172H225.188V182.639Z",
    fill: "#E8F4FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M225.188 199.854H215.907V204.043H225.188V199.854Z",
    fill: "#8CAFD4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M225.188 232.794H215.907V234.172H225.188V232.794Z",
    fill: "#E8F4FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M225.188 182.639H215.907V186.561H225.188V182.639Z",
    fill: "#E8F4FF"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M220.544 257.481C216.522 257.481 213.266 254.229 213.266 250.213V235.613H227.814V250.213C227.814 254.229 224.557 257.481 220.536 257.481H220.544Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M227.822 235.613H213.273V241.763H227.822V235.613Z",
    fill: "#E8F4FF"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M212.99 174.292H228.106V179.103C228.106 179.505 227.783 179.828 227.38 179.828H213.715C213.313 179.828 212.99 179.505 212.99 179.103V174.292Z",
    fill: "#8CAFD4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M212.99 174.292H228.106V179.103C228.106 179.505 227.783 179.828 227.38 179.828H213.715C213.313 179.828 212.99 179.505 212.99 179.103V174.292Z",
    fill: "#B8CDE0"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M214.109 179.828H226.994V183.072C226.994 183.474 226.671 183.797 226.269 183.797H214.843C214.441 183.797 214.117 183.474 214.117 183.072V179.828H214.109Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M226.994 179.828H214.109V181.119H226.994V179.828Z",
    fill: "#E8F4FF"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M215.229 196.625H225.866C226.489 196.625 226.986 197.129 226.986 197.743V199.861C226.986 200.263 226.663 200.586 226.261 200.586H214.835C214.433 200.586 214.109 200.263 214.109 199.861V197.743C214.109 197.121 214.614 196.625 215.229 196.625Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M226.994 196.625H214.109V197.916H226.994V196.625Z",
    fill: "#E8F4FF"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M269.843 154.534L266.145 158.59L257.203 168.41C252.984 173.032 247.015 175.67 240.754 175.67H198.741C192.48 175.67 186.511 173.032 182.292 168.41L173.351 158.59L169.652 154.534H269.843Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M269.843 154.534L266.145 158.59H173.351L169.652 154.534H269.843Z",
    fill: "#E8F4FF"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M270.489 141.927H169.006C166.889 141.927 165.173 143.64 165.173 145.754V150.707C165.173 152.821 166.889 154.534 169.006 154.534H270.489C272.606 154.534 274.322 152.821 274.322 150.707V145.754C274.322 143.64 272.606 141.927 270.489 141.927Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M228.043 237.133H213.061C212.24 237.133 211.578 236.471 211.578 235.652C211.578 234.833 212.24 234.172 213.061 234.172H228.043C228.863 234.172 229.525 234.833 229.525 235.652C229.525 236.471 228.863 237.133 228.043 237.133Z",
    fill: "#E8F4FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 138.399H243.293V141.935H250.5V138.399Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 138.399H243.293V140.163H250.5V138.399Z",
    fill: "#E8F4FF"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M251.462 135.8H242.323V138.399H251.462V135.8Z",
    fill: "#E8F4FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M198.276 138.399H191.068V141.935H198.276V138.399Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M198.276 138.399H191.068V140.163H198.276V138.399Z",
    fill: "#E8F4FF"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M199.245 135.8H190.106V138.399H199.245V135.8Z",
    fill: "#E8F4FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M203.157 125.461V126.067C203.157 126.579 203.401 126.996 203.717 127.02C206.358 127.193 217.571 128.737 221.072 142.163H233.602C233.602 142.163 224.936 125.736 209.008 122.382C207.888 122.145 206.705 121.972 205.475 121.878C204.213 121.775 203.149 123.405 203.149 125.461H203.157Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M226.757 142.155H221.072C218.785 133.414 213.242 129.705 208.913 128.146C206.595 127.303 204.631 127.083 203.709 127.02C203.393 126.996 203.149 126.579 203.149 126.067V125.405C203.149 124.831 203.251 124.295 203.401 123.815C209.922 123.728 216.373 126.886 221.624 133.335C223.682 135.863 225.33 138.879 226.75 142.155H226.757Z",
    fill: "#E8F4FF"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M208.921 128.138C206.603 127.296 204.639 127.075 203.717 127.012C203.401 126.988 203.157 126.571 203.157 126.059V125.398H206.926C207.927 125.398 208.763 126.579 208.921 128.138Z",
    fill: "#8CAFD4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M115.52 275.128C115.52 275.128 152.557 295.839 166.664 303.792C180.771 311.746 179.146 323.149 179.083 327.354L78.6324 327.007L82.5435 311.132C82.5435 311.132 119.092 318.337 129.303 320.739C129.303 320.739 97.7937 317.148 82.5435 311.132C67.2933 305.115 60.9062 297.745 60.9062 297.745L115.52 275.128Z",
    fill: "#003D7D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6344 312.297L64.9355 310.053C64.9355 310.053 48.8574 316.613 44.7964 320.574C43.5348 321.81 40.4043 325.275 41.3663 326.755C42.4309 328.377 44.8674 326.755 49.1255 326.755C52.6975 326.755 62.4516 326.716 65.4796 326.716C68.957 326.716 73.4674 326.724 73.4674 326.724L74.6344 312.289V312.297Z",
    fill: "#133A50"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2938 312.092L72.5684 328.228L86.6515 328.259L89.6952 310.242L73.2938 312.092Z",
    fill: "#2873AC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M108.73 168.347C108.73 168.347 101.515 173.898 97.0917 178.348C95.1598 180.293 95.1914 180.71 92.3369 180.71L116.568 200.759C116.568 200.759 112.768 195.877 114.203 191.514C115.496 187.585 121.134 178.552 125.037 175.678L108.738 168.354L108.73 168.347Z",
    fill: "#FEC4AD"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M106.743 173.016C105.71 177.599 110.315 185.821 112.705 190.388C113.099 191.152 113.517 191.908 113.943 192.664C113.998 192.278 114.069 191.892 114.195 191.514C115.488 187.585 121.126 178.552 125.029 175.678L108.73 168.354C108.73 168.354 108.013 168.906 106.885 169.803C107.027 170.796 107.004 171.874 106.743 173.024V173.016Z",
    fill: "#F0B9A3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M135.99 164.094C136.384 165.189 139.065 170.378 138.781 171.378C138.395 172.756 134.791 172.063 133.9 173.197C132.457 175.04 133.411 176.497 132.615 178.584C131.645 181.112 132.024 184.734 130.383 186.214C127.655 188.687 120.069 186.553 116.482 184.718C107.981 180.371 101.468 171.055 103.684 159.535C104.472 155.416 107.5 150.998 110.544 148.045C114.116 144.573 120.527 144.234 124.446 145.258C126.796 145.872 128.933 147.786 130.51 149.526C131.945 151.101 134.271 153.235 134.831 155.456C134.831 155.456 135.091 161.622 135.982 164.094H135.99Z",
    fill: "#FEC4AD"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1892 147.258C99.1892 147.258 98.9448 145.943 100.892 142.313C104.149 136.241 118.374 136.296 128.657 138.32C132.087 138.997 135.54 136.359 137.386 138.493C138.805 140.131 137.819 150.557 135.572 152.762C131.826 156.448 120.645 153.062 116.403 151.29C113.351 150.014 117.27 154.826 117.869 157.219C118.264 158.779 116.119 164.291 115.906 165.362C112.421 164.472 113.856 161.566 111.348 159.338C109.03 157.282 106.562 160.417 107.287 163C108.415 167 111.522 167.394 111.522 167.394C111.396 169.52 109.905 171.693 109.905 171.693C109.905 171.693 103.439 174.386 102.099 173.001C101.09 171.961 96.6265 163.007 95.491 160.456C93.0623 155.022 94.5448 150.534 99.1892 147.25V147.258Z",
    fill: "#411919"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M92.337 180.718C92.337 180.718 87.8897 180.867 80.6825 189.27C46.8152 228.73 60.9141 297.752 60.9141 297.752C60.9141 297.752 91.0911 303.879 113.328 269.49C113.328 269.49 110.426 259.426 111.585 244.645C112.894 228.014 118.161 206.011 115.504 197.294C114.447 193.829 110.591 192.727 107.043 189.845C98.8976 183.23 92.3291 180.71 92.3291 180.71L92.337 180.718Z",
    fill: "#FFBC00"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0471 182.545C89.7503 182.529 98.0536 181.009 111.348 199.499C113.241 202.137 115.244 203.87 116.19 206.248C115.732 216.887 112.562 232.25 111.585 244.645C110.418 259.426 113.327 269.49 113.327 269.49C91.083 303.879 60.9138 297.752 60.9138 297.752C60.9138 297.752 46.807 228.73 80.6823 189.27C82.9532 186.624 85.5554 184.379 88.055 182.545H88.0471Z",
    fill: "#004B9A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M103.25 194.727C94.9944 182.001 85.0116 183.096 79.0582 194.727C73.1048 206.358 66.1658 243.33 68.9414 254.882C71.717 266.435 85.9342 270.592 94.332 258.119C102.722 245.637 106.893 215.926 107.351 209.295C107.816 202.665 105.308 197.908 103.25 194.727Z",
    fill: "#FFBC00"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9141 297.752L67.3011 305.123C77.7413 317.172 109.424 320.125 121.915 310.218L147.715 279.081L137.496 306.73L149.348 310.053C149.348 310.053 179.966 270.632 177.695 253.496C177.285 250.409 173.808 242.81 169.447 243.535C144.017 247.771 104.354 266.19 104.354 266.19L60.9141 297.752Z",
    fill: "#004B9A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M133.679 316.172L130.588 326.897L166.301 327.921C166.301 327.921 163.754 323.519 161.759 322.227C158.991 320.432 147.723 317.211 147.723 317.211L133.672 316.172H133.679Z",
    fill: "#133A50"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M133.356 316.447L147.731 317.219L152.983 308.281L136.337 303.186L133.356 316.447Z",
    fill: "#2873AC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M183.72 248.204L190.872 241.928L196.186 239.81L201.067 241.708L198.741 245.212L183.72 248.204Z",
    fill: "#E6B397"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M199.75 213.469L195.248 212.414L196.099 208.823L200.444 205.145L201.643 205.429L199.75 213.469Z",
    fill: "#E8F4FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M204.284 214.54L208.787 215.595L209.63 212.004L207.375 206.775L206.177 206.5L204.284 214.54Z",
    fill: "#E8F4FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M191.455 211.524L189.878 218.233C189.752 218.753 189.807 219.304 190.028 219.792L194.191 225.005L199.821 226.328L206.374 223.635C206.792 223.297 207.084 222.832 207.21 222.304L208.787 215.595L191.455 211.524Z",
    fill: "#E8F4FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M193.857 214.332L192.913 214.11L192.214 217.077L193.158 217.299L193.857 214.332Z",
    fill: "#4B698F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M195.625 214.728L194.681 214.506L193.982 217.472L194.926 217.694L195.625 214.728Z",
    fill: "#4B698F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M197.369 215.139L196.425 214.917L195.726 217.884L196.67 218.106L197.369 215.139Z",
    fill: "#4B698F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M199.098 215.549L198.154 215.327L197.455 218.293L198.399 218.515L199.098 215.549Z",
    fill: "#4B698F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M195.648 210.695L195.246 212.405L199.744 213.462L200.146 211.752L195.648 210.695Z",
    fill: "#E8F4FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M204.695 212.832L204.292 214.541L208.79 215.598L209.193 213.889L204.695 212.832Z",
    fill: "#E8F4FF"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M197.03 241.133L199.679 226.297L194.325 225.037L190.264 239.841C192.511 240.298 194.767 240.723 197.022 241.133H197.03Z",
    fill: "#E8F4FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M199.277 228.573L199.687 226.297L194.333 225.037L193.978 226.336C195.744 227.084 197.511 227.84 199.277 228.573Z",
    fill: "#E8F4FF"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M198.208 238.592L190.501 236.781L183.478 266.592L191.184 268.403L198.208 238.592Z",
    fill: "#4B698F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M187.883 265.182C187.441 265.08 187.165 264.639 187.276 264.198L192.835 240.597C192.937 240.156 193.379 239.881 193.821 239.991C194.262 240.093 194.538 240.534 194.428 240.975L188.869 264.576C188.766 265.017 188.325 265.293 187.883 265.182Z",
    fill: "#B8CDE0"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M176.836 247.724C176.836 247.724 184.327 247.149 186.669 246.48C189.011 245.811 194.404 245.811 196.565 244.732C199.727 243.149 201.075 241.708 201.075 241.708L201.958 244.645L201.399 246.07L201.123 250.212L199.396 254.638C199.948 255.859 199.191 257.497 199.191 257.497L194.436 259.552C194.436 259.552 186.109 258.591 184.082 258.237C182.056 257.883 174.573 258.237 174.573 258.237L176.852 247.716L176.836 247.724Z",
    fill: "#FEC4AD"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1813 191.057C99.1813 191.057 119.399 228.407 131.669 234.345C142.14 239.408 176.836 247.732 176.836 247.732L177.277 260.883C177.277 260.883 130.991 258.528 118.437 251.228C106.168 244.086 80.5089 218.28 76.7791 203.696C75.1863 197.475 80.7139 179.103 99.1734 191.065L99.1813 191.057Z",
    fill: "#FFBC00"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M185.044 248.071C183.302 245.692 189.263 242.07 189.263 242.07L189.082 244.676C190.012 245.968 192.456 247.504 192.456 247.504L185.052 248.071H185.044Z",
    fill: "#FEC4AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_1225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 501,
    height: 333,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.8ef27bce8a77b94f24f3aa7d88e08077.svg";
export { ForwardRef as ReactComponent };